<script lang="ts">
  import type { Image } from "bildebanken-model";
  import type { EditImageActor } from "./editImageMachine";
  import { getImageVisibility, getVisibilityOptions, type VisibilityKey } from "./visibility";
  import { getCurrentUser } from "../../services/api";
  import { editState } from "./editSession";
  import { getAllEditedImages } from "./editImageMachine";

  export let service: EditImageActor;
  export let image: Image;

  const initialValue = getImageVisibility(image);
  const options = getVisibilityOptions();

  const currentUserId = getCurrentUser().id;
  $: images = $editState ? getAllEditedImages($editState) : [image];
  $: containsImageWithAnotherOwner = images.some((image) => image.createdBy !== currentUserId);

  $: filteredOptions = Object.entries(options).filter(
    ([_, option]) => {
      return !(option.value.level === "owner" && containsImageWithAnotherOwner);
    }
  );

  function onSelectVisibility(this: HTMLSelectElement & { value: VisibilityKey }) {
    service.send({ type: "EDIT_VISIBILITY", value: options[this.value]!.value });
  }

</script>

<label>
  Synlighet
  <select class="org-input" on:change={onSelectVisibility} value={initialValue}>
    {#each filteredOptions as [key, option]}
      <option value={key}>
        {option.label}
      </option>
    {/each}
  </select>
</label>
